import PropTypes from "prop-types"
import React from "react"
import TextChartODD13GHGEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsMolecule"
import TextChartODD13EnergyMixMolecule from "views/molecules/canvases/charts/TextChartODD13EnergyMixMolecule"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"
import { useAppContext } from "components/AppContext"
import { useTranslation } from "react-i18next"
import DonutChartTemplate from "views/molecules/charts/template/DonutChartTemplate"
import BrokerManufBreakdown from "views/molecules/charts/brocker/BrokerManufBreakdown"
import BrokerModelBreakdown from "views/molecules/charts/brocker/BrokerModelBreakdown"
import TextChartODD13GHGEmissionsAverageMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsAverageMolecule"
import { EnergyMixKpi } from "views/atoms/charts/kpi/energyMix/EnergyMixKpi"
// import ScoreChartErrorBoundary from "components/ErrorBoundary/ScoreChartErrorBoundary"

const Objective13LeaserScoreLayoutOrganism = ({ score }) => {
  const { t } = useTranslation()
  const { currentRootNode, score: globalScore } = useAppContext()

  const chart1TrendBadge = globalScore?.trend_badges?.odd13_CO2
  const chart2TrendBadge = globalScore?.trend_badges?.odd13_energy_mix
  const chart5TrendBadge =
    globalScore?.trend_badges?.odd13_co2_average_equipments

  const chart3 = () => {
    const { datasets, unit_key } = score.lease_odd13_use_vs_fab
    const data = datasets.map((dataset) => dataset.value)
    const temporaryDatasets = [score?.odd13_CO2, 0]
    const labels = datasets.map((dataset) => dataset.label)

    if (score?.is_consolidated) {
      return (
        <DonutChartTemplate
          title={t(
            "score:score.13.leaserChartEmissionBreakdownPerRegion.title"
          )}
          data={score?.emissions_breakdown?.data}
          labelKeys={score?.emissions_breakdown?.labels}
          unitPath="units:units.emission"
          unitKey={score?.emissions_breakdown?.unit_key}
          helpText={t(
            "score:score.13.leaserChartEmissionBreakdownPerRegion.help"
          )}
        />
      )
    } else if (score.has_only_sold_equipment) {
      // return <ScoreChartErrorBoundary />
      return (
        <DonutChartTemplate
          title={t(
            "score:score.13.leaserChartEmissionBreakdownPerLifecyclePhase.title"
          )}
          data={temporaryDatasets}
          labelPath={
            "score:score.13.leaserChartEmissionBreakdownPerLifecyclePhase.labels"
          }
          labelKeys={labels}
          unitPath="units:units.emission"
          unitKey={unit_key}
          helpText={t(
            "score:score.13.leaserChartEmissionBreakdownPerLifecyclePhase.help"
          )}
        />
      )
    } else {
      return (
        <DonutChartTemplate
          title={t(
            "score:score.13.leaserChartEmissionBreakdownPerLifecyclePhase.title"
          )}
          data={data}
          labelPath={
            "score:score.13.leaserChartEmissionBreakdownPerLifecyclePhase.labels"
          }
          labelKeys={labels}
          unitPath="units:units.emission"
          unitKey={unit_key}
          helpText={t(
            "score:score.13.leaserChartEmissionBreakdownPerLifecyclePhase.help"
          )}
        />
      )
    }
  }

  return (
    <ScoreLayoutOrganism
      maturity={score.odd13_maturity ?? 0}
      chart1={
        <TextChartODD13GHGEmissionsMolecule
          score={score}
          ghgEmissions={score?.odd13_CO2}
          hidePercentage={
            !score?.odd13_global_node_parent_score_defined ||
            !score?.should_diplay_percentage
          }
          trendBadge={chart1TrendBadge}
        />
      }
      chart2={
        <TextChartODD13EnergyMixMolecule
          energyMixStatus={score?.odd13_energy_mix_status}
          energyMixValue={
            currentRootNode?.methodology === "bilan_carbone"
              ? Number(score?.odd13_energy_mix_value)
              : Number(score?.odd7_market_based_emission_factor)
          }
          country={EnergyMixKpi(score)}
          trendBadge={chart2TrendBadge}
        />
      }
      chart3={chart3()}
      chart4={<BrokerManufBreakdown score={score?.assets_impacts} />}
      chart5={
        <TextChartODD13GHGEmissionsAverageMolecule
          score={score}
          trendBadge={chart5TrendBadge}
        />
      }
      chart6={<BrokerModelBreakdown score={score?.assets_impacts} />}
    />
  )
}

Objective13LeaserScoreLayoutOrganism.propTypes = {
  score: PropTypes.object.isRequired,
}

Objective13LeaserScoreLayoutOrganism.defaultProps = {}

export default Objective13LeaserScoreLayoutOrganism
